import { Directive, Input } from '@angular/core';
import { AsyncValidatorFn, AsyncValidator, NG_ASYNC_VALIDATORS, AbstractControl, ValidationErrors } from '@angular/forms';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Constants } from '../constants';
import { DirtyWordsService } from '../services/dirty-words/dirty-words.service';

/**
 * Custom Control Validetor For Visual IDs
 * @return AsyncValidatorFn
 */
export function dirtyWordValidator(dirtyWordsService: DirtyWordsService): AsyncValidatorFn {
  return (control: AbstractControl): Observable<ValidationErrors | null> => {
    return dirtyWordsService.verifyDirtyWord(control.value.trim()).pipe(
      map((res) => {
        if (res[Constants.DIRTY_WORD_FOUND]) {
          return {
            'invalid-word': true
          };
        } else {
          return null;
        }
      })
    );
  };
}


@Directive({
  selector: '[appDirtyWordsValidator][ngModel]',
  providers: [
    {
      provide: NG_ASYNC_VALIDATORS,
      useExisting: DirtyWordsValidatorDirective,
      multi: true
    }
  ]
})
export class DirtyWordsValidatorDirective implements AsyncValidator {
  constructor(private _dirtyWordService: DirtyWordsService) { }

  validate(control: AbstractControl): Promise<ValidationErrors | null> | Observable<ValidationErrors | null> {
    return dirtyWordValidator(this._dirtyWordService)(control);
  }
}
